import React, { ReactElement } from 'react'
import styled from 'styled-components'

import Field from '../../../../../../1stlog-ui/src/components/Field'
import Input from '../../../../../../1stlog-ui/src/components/Input'

const Wrapper = styled.div``

const CustomerReference = (): ReactElement => {
  return (
    <Wrapper>
      <Field
        name="customerReferenceText"
        label={i18n.t('customer_reference', 'Kundenreferenz')}
      >
        <Input isClearable />
      </Field>
    </Wrapper>
  )
}

export default CustomerReference
